var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "13",
        height: "13",
        viewBox: "0 0 13 13",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M11.2071 9.36918L7.07506 3.67269C6.92506 3.46644 6.61803 3.46644 6.4692 3.67269L2.336 9.36918C2.32583 9.38319 2.31974 9.39974 2.3184 9.417C2.31706 9.43426 2.32052 9.45156 2.32841 9.46697C2.3363 9.48238 2.3483 9.49531 2.36308 9.50432C2.37787 9.51332 2.39486 9.51806 2.41217 9.51801H3.29108C3.35084 9.51801 3.40709 9.48871 3.44225 9.44066L6.77155 4.8516L10.1008 9.44066C10.136 9.48871 10.1923 9.51801 10.252 9.51801H11.1309C11.2071 9.51801 11.2516 9.43129 11.2071 9.36918Z",
          fill: "currentColor",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }